import { Button, Card, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Datatable } from "../../components/functional";
import { UserDataProps } from "../../interfaces/interfaces";
import { CardTitle, ColumnComponent } from "../../components/ui";
import { FileAddOutlined, DeleteOutlined } from "@ant-design/icons";
import DataContext from "../../context/DataContext";
import { UserModal } from "../../components/pages/user";
import { ColumnsType } from "antd/es/table";
import AuthContext from "../../context/AuthContext";

export const UserPage = () => {
  const { userData, fetchUserData, onEditUser, handleRemoveUser } =
    useContext(DataContext);
  const { idRole } = useContext(AuthContext);
  const [openUserModal, setOpenUserModal] = useState(false);

  useEffect(() => {
    fetchUserData();
  }, []);

  const buttons = [
    {
      title: "New",
      icon: <FileAddOutlined />,
      disabled: false,
      action: () => {
        onEditUser(undefined);
        setOpenUserModal(true);
      },
    },
  ];

  const UserTableColumns: ColumnsType<UserDataProps> = [
    {
      title: "Name",
      dataIndex: "Name",
    },
    {
      title: "Username",
      dataIndex: "UserName",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>
          <Button
            disabled={record.UserName === "justin@crystin.com"}
            type="primary"
            style={{ marginRight: 8 }}
            onClick={() => {
              onEditUser(record);
              setOpenUserModal(true);
            }}
          >
            Edit
          </Button>
          <Button
            disabled={record.UserName === "justin@crystin.com"}
            danger
            onClick={() => {
              import("antd").then(({ Modal }) => {
                Modal.confirm({
                  title: "Are you sure you want to remove this user?",
                  content: `User: ${record.Name}`,
                  okText: "Yes",
                  okType: "danger",
                  cancelText: "No",
                  onOk() {
                    handleRemoveUser(record.OID);
                  },
                });
              });
            }}
          >
            Remove
          </Button>
        </>
      ),
    },
  ];
  return (
    <>
      <Row>
        <ColumnComponent>
          <CardTitle title="Users" buttons={buttons} />
        </ColumnComponent>
        <ColumnComponent>
          <Card bordered hoverable className="card overflow_x">
            <Datatable<UserDataProps>
              columns={UserTableColumns}
              data={userData}
              rowKey="OID"
              // onRowClick={(user) => {
              //   onEditUser(user);
              //   setOpenUserModal(true);
              // }}
            />
          </Card>
        </ColumnComponent>
      </Row>
      <UserModal
        open={openUserModal}
        onClose={() => {
          onEditUser(undefined);
          setOpenUserModal(false);
        }}
      />
    </>
  );
};
